var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, makeObservable, observable } from 'mobx';
import { Guest, Guest as GuestModel } from '@data/models';
import { persistentPropertyStorage } from '../PersistentPropertyStorage';
export default class Guests {
    constructor() {
        Object.defineProperty(this, "additional", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "main", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Guest()
        });
        Object.defineProperty(this, "clear", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.main = new Guest();
                this.additional = [];
            }
        });
        makeObservable(this);
    }
    get storageKey() {
        return 'guests';
    }
    add(guest) {
        return this.additional.push(guest);
    }
    load() {
        const loadedData = persistentPropertyStorage.getItem(this.storageKey);
        if (loadedData) {
            const parsedData = JSON.parse(loadedData);
            this.main = parsedData.main;
            this.additional = parsedData.additional;
        }
    }
    remove(index) {
        if (this.additional.length > index) {
            this.additional.splice(index, 1);
        }
    }
    save() {
        persistentPropertyStorage.setItem(this.storageKey, JSON.stringify(this));
    }
    update(index, guest) {
        if (index >= 0 && this.additional.length > index) {
            this.additional[index] = guest;
        }
    }
    updateMainGuest(guest) {
        const definedGuest = Object.fromEntries(Object.entries(guest).filter(([, value]) => value !== undefined));
        this.main = Object.assign(Object.assign({}, this.main), definedGuest);
    }
    updateMarketingOptin(value) {
        this.main = Object.assign(Object.assign({}, this.main), { isOptIn: value });
    }
}
__decorate([
    observable,
    __metadata("design:type", Array)
], Guests.prototype, "additional", void 0);
__decorate([
    observable,
    __metadata("design:type", Guest)
], Guests.prototype, "main", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GuestModel]),
    __metadata("design:returntype", void 0)
], Guests.prototype, "add", null);
__decorate([
    action.bound,
    __metadata("design:type", Object)
], Guests.prototype, "clear", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], Guests.prototype, "remove", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number, GuestModel]),
    __metadata("design:returntype", void 0)
], Guests.prototype, "update", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GuestModel]),
    __metadata("design:returntype", void 0)
], Guests.prototype, "updateMainGuest", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], Guests.prototype, "updateMarketingOptin", null);
